'use client'
import React, { useEffect, useRef, useState } from 'react'
import {
  Common,
  HttpService,
  Messages,
  ServiceEndpoints,
  SimpleReactValidator
} from '@/config/NextImport'
const DropHint = ({ data }: any) => {
  const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL
  
  const Validator = useRef(new SimpleReactValidator())
  const submitBtnRef = useRef<HTMLButtonElement>(null)
  const closeBtnRef = useRef<HTMLButtonElement>(null)
  const defaultInputs = {
    friend_email_1: '',
    friend_email_2: '',
    messages: '',
    name: '',
    email: '',
    ringsize: '',
    send_me_copy: false,
    subscribe: false
  }
  const [isToggled, setToggle] = useState(false)
  const [Success, setSuccess] = useState(false)
  const [Inputs, setInputs] = useState(defaultInputs)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const modalRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const modalEl = modalRef.current
    if (!modalEl) return
    modalEl.addEventListener('hidden.bs.modal', resetForm)
    return () => {
      modalEl.removeEventListener('hidden.bs.modal', resetForm)
    }
  }, [])

  const handleInputChanges = (prop: any) => (event: any) => {
    if (prop === Messages.send_me_copy || prop === Messages.subscribe)
      setInputs({ ...Inputs, [prop]: event.target.checked })
    else setInputs({ ...Inputs, [prop]: event.target.value })
  }

  const cleanPath = (url = '') => url.split('?')[0].replace(/\/$/, '')
  const slugify = (str = '') => str.trim().replace(/\s+/g, '-').toLowerCase()
  const dropHintSubmit = async (e: any) => {
    e.preventDefault()
    if (!Validator.current.allValid()) {
      Validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    } else {
      Validator.current.hideMessages()
      setForceUpdate(!isForceUpdate)
    }
    const param = {
      frined_email: Inputs.friend_email_1,
      frined_email_2: Inputs.friend_email_2,
      messages: Inputs.messages,
      your_name: Inputs.name,
      your_email: Inputs.email,
      ring_size: Inputs.ringsize,
      send_me_copy: Inputs.send_me_copy ?? 0,
      subscribe: Inputs.subscribe ?? 0,
      setting: {},
      diamond: {}
    }
    if (Object.entries(data).length === 1 && data.detail?.is_diamond === 0) {
      //setting
      param.setting = {
        parent_sku: data.detail.parent_sku,
        sku: data.detail.sku,
        model_number: data.detail.model_number,
        name: Common.toTitleCase(data.detail.name),
        image: data.detail.base_image,
        price: data.detail.formated_price,
        formated_special_price: data.detail.formated_special_price,
        special_price: data.detail.special_price,
        metal_quality: data.detail.metal_quality_value,
        product_url: SITE_URL + data.detail.setting_url.split("?")[0] + '/' + data.detail.name.toLowerCase().split(' ').join('-') + '-sku-' + data.detail.sku
      }
    } else if (Object.entries(data).length === 1 && data.detail?.is_diamond === 1) {
      //diamond
      const diamondurl = data.detail.is_gemstone ? data.detail.gemstone_url : data.detail.diamond_url
      param.diamond = {
        sku: data.detail.sku,
        name: Common.toTitleCase(data.detail.name),
        image: data.detail.base_image,
        price: data.detail.formated_price,
        metal_quality: data.detail.metal_quality_value,
        product_url: SITE_URL + diamondurl.split("?")[0] + '/' + data.detail.name.toLowerCase().split(' ').join('-') + '-sku-' + data.detail.sku
      }
    } else {
      if (data.detail?.is_diamond === 0) {
        param.setting = {
          sku: data.detail.sku,
          parent_sku: data.detail.parent_sku,
          model_number: data.detail.model_number,
          name: Common.toTitleCase(data.detail.name),
          image: data.detail.base_image,
          price: data.detail.formated_price,
          formated_special_price: data.detail.formated_special_price,
          special_price: data.detail.special_price,
          metal_quality: data.detail.metal_quality_value,
          product_url: SITE_URL + data.detail.setting_url.split("?")[0] + '/' + data.detail.name.toLowerCase().split(' ').join('-') + '-sku-' + data.detail.sku
        }
      }
      if (data.diamond?.is_diamond === 1) {
        const diamondurl = data.detail.is_gemstone ? data.detail.gemstone_url : data.detail.diamond_url
        param.diamond = {
          sku: data.diamond.sku,
          certificate: data.diamond.certificate,
          name: Common.toTitleCase(data.diamond.name),
          image: data.diamond.base_image,
          price: data.diamond.formated_price,
          product_url: SITE_URL + diamondurl.split("?")[0] + '/' + data.diamond.name.toLowerCase().split(' ').join('-') + '-sku-' + data.diamond.sku
        }
      }
    }
    if (submitBtnRef.current) submitBtnRef.current.setAttribute('disabled', 'disabled')
    HttpService.postApi(ServiceEndpoints.sendDropHint, param).then(async (response) => {
      try {
        if (submitBtnRef.current) submitBtnRef.current.removeAttribute('disabled')
        setSuccess(true)
        setInputs(defaultInputs)
        setForceUpdate(!isForceUpdate)
        // setTimeout(() => {
        //   setSuccess(false)
        // }, 4000)
      } catch (error) {
        // console.log(error(error)
      }
    })
  }
  const resetForm = (e: any) => {
    e.preventDefault()
    setInputs(defaultInputs)
    setSuccess(false)
    Validator.current.hideMessages()
    setForceUpdate(!isForceUpdate)
  }

  const handleToggle = () => {
    setToggle(true)
  }
  const handleToggleClosed = () => {
    setToggle(false)
  }

  return (
    <div
      className="modal fade"
      id="DropHintModal"
      //  tabIndex="-1"
      aria-labelledby="DropHintModalLabel"
      aria-hidden="true"
      ref={modalRef}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              id="closeHintModal"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetForm}
              ref={closeBtnRef}
            ></button>
          </div>
          <div className="modal-body pt-0">
            <form
              className="form-register form-box"
              onSubmit={dropHintSubmit}
            >
              <div className="form-title text-center mb-3">
                <h2>Share The Love!</h2>
                <p className="drop-hint-text">
                  Found something you love? Let your friends know! Click the share button to send
                  details to your friends.
                </p>
              </div>
              <div className={Success ? 'alert alert-success' : 'alert alert-success d-none'}>
                Information shared successfully!
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Friend's Email Address"
                      name="friend_email_1"
                      onChange={handleInputChanges('friend_email_1')}
                      value={Inputs.friend_email_1}
                    />
                    {Validator.current.message(
                      'Email Address',
                      Inputs.friend_email_1,
                      'required|email|max:255',
                      {
                        className: 'error'
                      }
                    )}
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Second Friend's Email Address (Optional)"
                      name="friend_email_2"
                      onChange={handleInputChanges('friend_email_2')}
                      value={Inputs.friend_email_2}
                    />
                    {Validator.current.message(
                      'Email Address',
                      Inputs.friend_email_2,
                      'email|max:255',
                      {
                        className: 'error'
                      }
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Your Name"
                      name="name"
                      onChange={handleInputChanges('name')}
                      value={Inputs.name}
                    />
                    {Validator.current.message('Your Name', Inputs.name, 'required|max:255', {
                      className: 'error'
                    })}
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Your Email Address"
                      name="email"
                      onChange={handleInputChanges('email')}
                      value={Inputs.email}
                    />
                    {Validator.current.message('Email', Inputs.email, 'required|email|max:255', {
                      className: 'error'
                    })}
                  </div>
                  {/* <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Your Size (Optional)"
                      name="ringsize"
                      onChange={handleInputChanges('ringsize')}
                      value={Inputs.ringsize}
                    />
                  </div> */}
                </div>
                <div className="col-md-12">
                  <div className={isToggled ? 'addnote-optional active' : 'addnote-optional'}>
                    <div
                      className="addnote-optional-title cursor"
                      onClick={handleToggle}
                    >
                      + <u>Add Your Message</u> (optional)
                    </div>
                    <div className="form-group addnote-optional-box">
                      <div className="addnote-optional-title d-flex align-items-center justify-content-between mb-1">
                        <span
                          className="cursor"
                          onClick={handleToggleClosed}
                        >
                          Your Message (optional)
                        </span>
                        <button
                          type="button"
                          className="btn-close cursor"
                          onClick={handleToggleClosed}
                        ></button>
                      </div>
                      <textarea
                        // type="text"
                        style={{ minHeight: '4.5rem' }}
                        className="form-control"
                        name="messages"
                        onChange={handleInputChanges('messages')}
                        value={Inputs.messages}
                      ></textarea>
                    </div>
                  </div>
                  <div className="form-group mb-0">
                    <div className="form-check mb-0 mt-0">
                      <input
                        type="checkbox"
                        className="form-check-input ms-0"
                        id="send_me_copy"
                        name="send_me_copy"
                        checked={Inputs.send_me_copy}
                        onChange={handleInputChanges('send_me_copy')}
                      />
                      <label
                        className="form-check-label mb-0"
                        htmlFor="send_me_copy"
                      >
                        Send me a copy of this email.
                      </label>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-check mt-0">
                      <input
                        type="checkbox"
                        className="form-check-input ms-0"
                        id="subscribe"
                        name="subscribe"
                        checked={Inputs.subscribe}
                        onChange={handleInputChanges('subscribe')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="subscribe"
                      >
                        Send me Harmony Jewels email updates.
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group text-center form-btn">
                    <button
                      type="submit"
                      className="button w-100 btn"
                      name="submit"
                      value="Drophint"
                      ref={submitBtnRef}
                    >
                      Share
                    </button>
                  </div>
                </div>
              </div>
              <div className="account-link mt-1">
                <p>
                  Your email address will only be used to inform your friend who sent this email,
                  unless you choose to receive offers and news from Harmony Jewels Jewelery.
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DropHint
